export default "__VITE_ASSET__qGeNL9Ew__"